module.exports = __webpack_public_path__ + "img/banner-princiapal.b4d53322.png";